import React from "react";

export function Contact() {
  return (
    <div>
      <h1>Estamos en Contact Web</h1>
    </div>
  );
}
